import React, { useState } from 'react';
import { AppProvider } from './context/AppContext';
import { ToastProvider } from './components/common/Toast';
import ErrorBoundary from './components/common/ErrorBoundary';
import Header from './components/Layout/Header';
import NavigationTabs from './components/Layout/NavigationTabs';
import HomeTab from './components/Home/HomeTab';
import JobDefinitionTab from './components/JobDefinition/JobDefinitionTab';
import CVUploadTab from './components/CVUpload/CVUploadTab';
import QuestionsTab from './components/Questions/QuestionsTab';
import AgentTab from './components/Agent/AgentTab';
import './styles/global.css';
import './styles/toast.css';

const App = () => {
  const [activeTab, setActiveTab] = useState('home');

  const renderActiveTab = () => {
    switch (activeTab) {
      case 'home':
        return <HomeTab onNavigate={setActiveTab} />;
      case 'jobDefinition':
        return <JobDefinitionTab />;
      case 'cvUpload':
        return <CVUploadTab />;
      case 'questions':
        return <QuestionsTab />;
      case 'agent':
        return <AgentTab />;
      default:
        return <HomeTab />;
    }
  };

  return (
    <ErrorBoundary>
      <ToastProvider>
        <AppProvider>
          <div className="container">
            <Header />
            <NavigationTabs activeTab={activeTab} onTabChange={setActiveTab} />
            {renderActiveTab()}
          </div>
        </AppProvider>
      </ToastProvider>
    </ErrorBoundary>
  );
};

export default App;
